import { NavigateFunction } from "react-router-dom";
import {
  incluirPessoaFisica,
  verificarDisponibilidadeCpf,
  incluirPessoaJuridica,
  verificarDisponibilidadeCnpj,
} from "../../../services/cliente";
import {
  verificarDisponibilidadeEmail,
  verificarDisponibilidadeUserName,
} from "../../../services/usuario";
import { Erro } from "../AlteracaoSenha/AlteracaoSenha";
import {
  ImagensDocumentacao,
  Usuario,
  UsuarioPJ,
  Socios,
} from "./Cadastro";
import { senhaAtendeRequisitos } from "../../../components/SegurancaSenha/functions";

export async function verificarUserName(
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  userName: string,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  email: string,
  setActive: (value: React.SetStateAction<number>) => void
) {
  setLoading(true);
  await verificarDisponibilidadeUserName(userName)
    .then(async () => {
      setError({
        erro: false,
        mensagem: "",
      });
      await verificarEmail(setLoading, setError, email, setActive);
    })
    .catch(async (e) => {
      let mensagem =
        "Algo deu errado aguarde um instante e tente novamente mais tarde.";
      const status = e.response?.data?.codigo ?? e.response?.status;
      if (status) {
        switch (status) {
          case 400:
            mensagem = "Esse Username já está sendo utilizado.";
            setError({
              erro: true,
              mensagem,
            });
            break;
          case 404:
            setError({
              erro: false,
              mensagem: "",
            });
            await verificarEmail(setLoading, setError, email, setActive);
            break;
          default:
            mensagem =
              "Algo deu errado aguarde um instante e tente novamente mais tarde.";
            setError({
              erro: true,
              mensagem,
            });
            break;
        }
      } else {
        setError({
          erro: true,
          mensagem,
        });
      }
      setLoading(false);
    });
}

export async function verificarEmail(
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  email: string,
  setActive: (value: React.SetStateAction<number>) => void
) {
  setLoading(true);
  await verificarDisponibilidadeEmail(email)
    .then(async () => {
      setLoading(false);
      setError({
        erro: false,
        mensagem: "",
      });
      setActive((value) => value + 1);
    })
    .catch((e) => {
      let mensagem =
        "Algo deu errado aguarde um instante e tente novamente mais tarde.";
      const status = e.response?.data?.codigo ?? e.response?.status;
      if (status) {
        switch (status) {
          case 400:
            mensagem = "Esse Email já está sendo utilizado.";
            setError({
              erro: true,
              mensagem,
            });
            break;
          case 404:
            setError({
              erro: false,
              mensagem: "",
            });
            setActive((value) => value + 1);
            break;
          default:
            mensagem =
              "Algo deu errado aguarde um instante e tente novamente mais tarde.";
            setError({
              erro: true,
              mensagem,
            });
            break;
        }
      } else {
        setError({
          erro: true,
          mensagem,
        });
      }
      setLoading(false);
    });
}

export async function verificarCpf(
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  CPF: string,
  setActive: (value: React.SetStateAction<number>) => void
) {
  setLoading(true);
  await verificarDisponibilidadeCpf(CPF)
    .then(async () => {
      setLoading(false);
      setError({
        erro: false,
        mensagem: "",
      });
      setActive((value) => value + 1);
    })
    .catch((e) => {
      let mensagem =
        "Algo deu errado aguarde um instante e tente novamente mais tarde.";
      const status = e.response?.data?.codigo ?? e.response?.status;
      if (status) {
        switch (status) {
          case 400:
            mensagem = "Esse CPF já está cadastrado.";
            setError({
              erro: true,
              mensagem,
            });
            break;
          case 404:
            setError({
              erro: false,
              mensagem: "",
            });
            setActive((value) => value + 1);
            break;
          default:
            mensagem =
              "Algo deu errado aguarde um instante e tente novamente mais tarde.";
            setError({
              erro: true,
              mensagem,
            });
            break;
        }
      } else {
        setError({
          erro: true,
          mensagem,
        });
      }
      setLoading(false);
    });
}

export async function verificarCnpj(
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  CNPJ: string,
  setActive: (value: React.SetStateAction<number>) => void
) {
  setLoading(true);
  await verificarDisponibilidadeCnpj(CNPJ)
    .then(async () => {
      setLoading(false);
      setError({
        erro: false,
        mensagem: "",
      });
      setActive((value) => value + 1);
    })
    .catch((e) => {
      let mensagem =
        "Algo deu errado aguarde um instante e tente novamente mais tarde.";
      const status = e.response?.data?.codigo ?? e.response?.status;
      if (status) {
        switch (status) {
          case 400:
            mensagem = "Esse CNPJ já está cadastrado.";
            setError({
              erro: true,
              mensagem,
            });
            break;
          case 404:
            setError({
              erro: false,
              mensagem: "",
            });
            setActive((value) => value + 1);
            break;
          default:
            mensagem =
              "Algo deu errado aguarde um instante e tente novamente mais tarde.";
            setError({
              erro: true,
              mensagem,
            });
            break;
        }
      } else {
        setError({
          erro: true,
          mensagem,
        });
      }
      setLoading(false);
    });
}

const obterMensagemErroCadastro = (error: any) => {
  const mensagemApi = error.response?.data?.mensagem;
  if (typeof mensagemApi === "string" && mensagemApi.trim() !== "") {
    if (mensagemApi === "Usuário já existe em nossa base de dados")
      return "Esse e-mail já está sendo utilizado.";

    return mensagemApi;
  }

  return "Não foi possível concluir o cadastro. Verifique os dados e tente novamente.";
};

export const onSubmitPF = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  userName: string,
  email: string,
  senha: string,
  imagemPerfil: string | ArrayBuffer | null,
  usuarioPF: Usuario,
  idsServicosFinanceiros: number[],
  imagensDocumentacao: ImagensDocumentacao[],
  navigate: NavigateFunction
) => {
  setLoading(true);
  await incluirPessoaFisica({
    email,
    senha,
    userName,
    imagemPerfil,
    ...usuarioPF,
    idsServicosFinanceiros,
    imagensDocumentacao,
  })
    .then(() => {
      setLoading(false);
      navigate("/confirmacao-usuario");
    })
    .catch((error) => {
      console.error("Erro incluirPessoaFisica ", error);
      setError({
        erro: true,
        mensagem: obterMensagemErroCadastro(error),
      });
      setLoading(false);
    })
    .finally(() => setLoading(false));
};

export const onSubmitPJ = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  userName: string,
  email: string,
  senha: string,
  imagemPerfil: string | ArrayBuffer | null,
  usuarioPJ: UsuarioPJ,
  socios: Socios[],
  idsServicosFinanceiros: number[],
  imagensDocumentacao: ImagensDocumentacao[],
  navigate: NavigateFunction
) => {
  setLoading(true);
  await incluirPessoaJuridica({
    email,
    senha,
    userName,
    imagemAvatar: imagemPerfil,
    ...usuarioPJ,
    socios,
    idsServicosFinanceiros,
    imagensDocumentacao,
  })
    .then(() => {
      setLoading(false);
      navigate("/confirmacao-usuario");
    })
    .catch((error) => {
      console.error("Erro incluirPessoaJuridica ", error);
      setError({
        erro: true,
        mensagem: obterMensagemErroCadastro(error),
      });
      setLoading(false);
    })
    .finally(() => setLoading(false));
};

export const verificarSeEmailEValido = (email: string) => {
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w\w+)+$/;
  if (reg.test(email) === false) {
    return false;
  } else {
    return true;
  }
};

const somenteDigitos = (valor: string) => valor.replace(/\D/g, "");
const campoPreenchido = (valor?: string | null) => Boolean(valor?.trim());

const bloquearAvanco = (
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  mensagem: string
) => {
  setError({
    erro: true,
    mensagem,
  });
  return false;
};

const validarDadosAcesso = (
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  userName: string,
  email: string,
  senha: string,
  senhaConfirmada: string
) => {
  if (![userName, email, senha, senhaConfirmada].every(campoPreenchido))
    return bloquearAvanco(
      setError,
      "Verifique se todos os campos foram preenchidos corretamente."
    );

  if (!senhaAtendeRequisitos(senha))
    return bloquearAvanco(
      setError,
      "Use uma senha com ao menos 7 caracteres, incluindo letra maiúscula, letra minúscula, número e caractere especial."
    );

  if (senha !== senhaConfirmada)
    return bloquearAvanco(
      setError,
      "Senha e confirmação de senha não são iguais."
    );

  if (!verificarSeEmailEValido(email))
    return bloquearAvanco(setError, "O e-mail digitado não é válido.");

  setError({
    erro: false,
    mensagem: "",
  });
  return true;
};

export const verificarSeCpfEValido = (valor: string) => {
  const cpf = somenteDigitos(valor);
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const calcularDigito = (quantidade: number, pesoInicial: number) => {
    const soma = cpf
      .slice(0, quantidade)
      .split("")
      .reduce((total, digito, index) => total + Number(digito) * (pesoInicial - index), 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  return calcularDigito(9, 10) === Number(cpf[9])
    && calcularDigito(10, 11) === Number(cpf[10]);
};

export const verificarSeCnpjEValido = (valor: string) => {
  const cnpj = somenteDigitos(valor);
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  const calcularDigito = (pesos: number[]) => {
    const soma = pesos.reduce(
      (total, peso, index) => total + Number(cnpj[index]) * peso,
      0
    );
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  return calcularDigito([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(cnpj[12])
    && calcularDigito([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(cnpj[13]);
};

export const habilitarBotaoProximoPF = (
  active: number,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  userName: string,
  email: string,
  senha: string,
  senhaConfirmada: string,
  imagePerfil: string | ArrayBuffer | null,
  usuarioPF: Usuario,
  idsServicosFinanceiros: number[],
  imagensDocumentacao: ImagensDocumentacao[]
) => {
  switch (active) {
    case 1:
      return validarDadosAcesso(setError, userName, email, senha, senhaConfirmada);
    case 2:
      if (
        usuarioPF.nome !== "" &&
        usuarioPF.cpf !== "" &&
        verificarSeCpfEValido(usuarioPF.cpf) &&
        usuarioPF.profissao !== "" &&
        usuarioPF.renda !== 0 &&
        usuarioPF.telefone !== "" &&
        usuarioPF.dataNascimento !== "" &&
        usuarioPF.nacionalidade !== "" &&
        usuarioPF.endereco.bairro !== "" &&
        usuarioPF.endereco.cep !== "" &&
        usuarioPF.endereco.cidade !== "" &&
        usuarioPF.endereco.complemento !== "" &&
        usuarioPF.endereco.estado !== "" &&
        usuarioPF.endereco.rua !== ""
      ) {
        return true;
      } else {
        setError({
          erro: true,
          mensagem:
            "Verifique se todos os campos foram preenchidos corretamente.",
        });
        return false;
      }
    case 3:
      if (idsServicosFinanceiros.length !== 0) {
        setError({
          erro: false,
          mensagem: "",
        });
        return true;
      } else {
        setError({
          erro: true,
          mensagem:
            "Verifique se todos os campos foram preenchidos corretamente.",
        });
        return false;
      }
    case 4:
      if (["CPF", "ComprovanteDeResidencia"].every((tipo) =>
        imagensDocumentacao.some((documento) => documento.tipoDocumento === tipo)
      )) {
        setError({
          erro: false,
          mensagem: "",
        });
        return true;
      } else {
        setError({
          erro: true,
          mensagem:
            "Verifique se todos os campos foram preenchidos corretamente.",
        });
        return false;
      }
  }
};

export const habilitarBotaoProximoPJ = (
  active: number,
  setError: React.Dispatch<React.SetStateAction<Erro>>,
  userName: string,
  email: string,
  senha: string,
  senhaConfirmada: string,
  imagePerfil: string | ArrayBuffer | null,
  usuarioPJ: UsuarioPJ,
  socios: Socios[],
  idsServicosFinanceiros: number[],
  imagensDocumentacao: ImagensDocumentacao[],
  confirmouEnvioSemDocumentosComplementares = false
) => {
  switch (active) {
    case 1:
      return validarDadosAcesso(setError, userName, email, senha, senhaConfirmada);
    case 2:
      if (!campoPreenchido(usuarioPJ.nome))
        return bloquearAvanco(setError, "Informe o nome da empresa.");

      if (!verificarSeCnpjEValido(usuarioPJ.cnpj))
        return bloquearAvanco(setError, "Informe um CNPJ válido.");

      if (!campoPreenchido(usuarioPJ.razaoSocial))
        return bloquearAvanco(setError, "Informe a razão social.");

      if (!campoPreenchido(usuarioPJ.telefone))
        return bloquearAvanco(setError, "Informe o telefone.");

      if (!campoPreenchido(usuarioPJ.endereco?.cep))
        return bloquearAvanco(setError, "Informe o CEP.");

      if (!campoPreenchido(usuarioPJ.endereco?.cidade))
        return bloquearAvanco(setError, "Informe a cidade.");

      if (!campoPreenchido(usuarioPJ.endereco?.estado))
        return bloquearAvanco(setError, "Informe o UF.");

      if (!campoPreenchido(usuarioPJ.endereco?.rua))
        return bloquearAvanco(setError, "Informe o endereço.");

      if (!campoPreenchido(usuarioPJ.endereco?.bairro))
        return bloquearAvanco(setError, "Informe o bairro.");

      if (!campoPreenchido(usuarioPJ.endereco?.complemento))
        return bloquearAvanco(setError, "Informe o complemento e número.");

      setError({
        erro: false,
        mensagem: "",
      });
      return true;
    case 3:
      if (idsServicosFinanceiros.length !== 0) {
        setError({
          erro: false,
          mensagem: "",
        });
        return true;
      } else {
        setError({
          erro: true,
          mensagem:
            "Verifique se todos os campos foram preenchidos corretamente.",
        });
        return false;
      }
    case 4: {
      if (!imagensDocumentacao.some((documento) => documento.tipoDocumento === "CNPJ"))
        return bloquearAvanco(setError, "Anexe o Cartão CNPJ para continuar.");

      const documentosComplementaresAusentes = [
        { tipo: "ContratoSocial", nome: "contrato social" },
        { tipo: "ComprovanteDeResidencia", nome: "comprovante de residência" },
      ].filter(({ tipo }) =>
        !imagensDocumentacao.some((documento) => documento.tipoDocumento === tipo)
      );

      if (documentosComplementaresAusentes.length > 0 && !confirmouEnvioSemDocumentosComplementares)
        return bloquearAvanco(
          setError,
          `Documentos opcionais não anexados: ${documentosComplementaresAusentes.map(({ nome }) => nome).join(" e ")}. Clique em Concluir novamente para seguir sem eles.`
        );

      setError({
        erro: false,
        mensagem: "",
      });
      return true;
    }
  }
};
